/**
 * 刷新钱包余额
 * 目前适用于随手记、卡牛
 */
import useragent from '@common/useragent'
import { call, uriSuishouji } from './bridge'
import { compare } from './version'

export default () => {
  if (useragent.isSuishouji) {
    const featureVersion = useragent.isAndroid ? '10.5.1.0' : '10.9.9'
    // 随手记新版本将不再提供 requestUpdateWallet 协议
    if (!compare(featureVersion)) {
      call(uriSuishouji('requestUpdateWallet'))
    }
  } else if (useragent.isKaniu) {
    call('cardniu://app/financeWalletEntranceUpdate?opt=1')
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestUpdateWallet.js